exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-btn-group{border-radius:2px;display:inline-flex}.theme--dark .v-btn-group{background:#424242}.theme--light .v-btn-group{background:#fff}.v-btn-group .v-btn{border-radius:0;justify-content:center;margin:0;min-width:auto;opacity:.4;padding:0 8px;width:auto}.v-btn-group .v-btn:not(:last-child){border-right:1px solid transparent}.v-btn-group .v-btn:first-child{border-radius:2px 0 0 2px}.v-btn-group .v-btn:last-child{border-radius:0 2px 2px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-51f823e8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/edition/components/VBtnGroup.vue
// module id = 2163
// module chunks = 0